
import React, { useEffect, useState } from 'react';
import { evaluateReviews } from 'redux/ducks/Review';
import { connect } from 'react-redux';
import { defaultStyleState } from './RatingSection';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const defaultEvaluateReview = {
  id: null,
  additionalFeedback: "",
  rating: null,
}

const RatingDetailSection = (props) => {
  const { index, setIndex, styleState, setStyleState, reviews, isOpen, openReviewModal } = props;
  const item = reviews[index];
  const { negativeFeedback, positiveFeedback } = styleState;
  const [disableFeedback, setDisableFeedback] = useState(true);
  const [evaluateReview, setEvaluateReview] = useState(defaultEvaluateReview);

  useEffect(() => {
    if (item) {
      setEvaluateReview({
        ...evaluateReview,
        id: item.id || reviews[index].id,
      })
    }
  }, [item]);

  const next = () => {
    setIndex((index + 1) % reviews.length);
    setStyleState(defaultStyleState);
    setEvaluateReview(defaultEvaluateReview);
    setDisableFeedback(true);
  };

  const previous = () => {
    setIndex((reviews.length + index - 1) % reviews.length);
    setStyleState(defaultStyleState);
    setEvaluateReview(defaultEvaluateReview);
    setDisableFeedback(true);
  };

  const onSubmit = review => {
    if (index !== 0) {
      setIndex(index - 1);
    }
    props.evaluateReview(review);
    setStyleState(defaultStyleState);
    setDisableFeedback(true);
    setEvaluateReview(defaultEvaluateReview);
  };

  const handlePositiveFeedback = () => {
    setEvaluateReview({
      ...evaluateReview,
      rating: 1,
    })
    setStyleState({
      ...styleState,
      positiveFeedback: true,
      negativeFeedback: false,
    })
    setDisableFeedback(false);
  };

  const handleNegativeFeedback = () => {
    setEvaluateReview({
      ...evaluateReview,
      rating: 0,
    })
    setStyleState({
      ...styleState,
      positiveFeedback: false,
      negativeFeedback: true,
    })
    setDisableFeedback(false);
  };

  const onChangeAdditionalFeedback = (e) => {
    e.preventDefault();
    setEvaluateReview({
      ...evaluateReview,
      additionalFeedback: e.target.value,
    });
  }

  const skip = () => {
    setIndex((index + 1) % reviews.length);
    setStyleState(defaultStyleState);
    setDisableFeedback(true);
    setEvaluateReview(defaultEvaluateReview);
  }

  if (!item) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={openReviewModal}
      className="rating-modal modal-dialog-centered"
    >
      <ModalHeader>
        <p className='font-weight-bold'>AT FEEDBACK REQUEST</p>
        <div className='d-flex flex-row justify-content-between'>
          <p className='mr-2' onClick={previous}> <i className='fas fa-caret-left fa-lg'></i></p>
          <p>{index + 1 + "/" + reviews.length}</p>
          <p className='ml-2' onClick={next}> <i className='fas fa-caret-right fa-lg'></i></p>
        </div>
      </ModalHeader>
      <ModalBody style={{ backgroundColor: "white" }}>
        <div className='font-weight-bold'>NAME: <span className='font-weight-normal'>{item.ATName}</span></div>
        <div className='font-weight-bold mb-2'>JOB WORKED: <span className='font-weight-normal'>{item.eventTitle}</span></div>
        <div className='d-flex flex-column justify-content-between'>
          <p className='font-weight-bold mt-2'>WOULD YOU HIRE THIS AT AGAIN?</p>
          <div className='mb-3'>
            <button className={`button ${positiveFeedback ? `light-teal-button` : `grey-button`}`} onClick={handlePositiveFeedback}>YES</button>
            <button className={`button ml-2 ${negativeFeedback ? `light-teal-button` : `grey-button`}`} onClick={handleNegativeFeedback}>NO</button>
          </div>
          <div>
            <label htmlFor="additionalFeedback" className='font-weight-bold'>ADDITIONAL FEEDBACK</label>
            <textarea
              className="form-control"
              style={{
                width: '100%',
                minHeight: '120px',
                border: '1px solid #b9b6ba',
                marginBottom: '10px',
              }}
              type="text"
              name="additionalFeedback"
              value={evaluateReview.additionalFeedback}
              onChange={onChangeAdditionalFeedback}
            />
          </div>
        </div>
        <div className='footer-rating-modal'>
          <button disabled={disableFeedback} className='btn btn-danger btn-bold font-italic font-weight-bold' onClick={() => onSubmit(evaluateReview)}>LEAVE FEEDBACK</button>
          <button disabled={reviews.length === 1} className='ml-2 skip-button' onClick={skip}><u>SKIP</u></button>
        </div>
      </ModalBody>
    </Modal>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    evaluateReview: review => dispatch(evaluateReviews(review)),
  };
}

export default connect(null, mapDispatchToProps)(RatingDetailSection);
